export default __webpack_public_path__ + "static/media/cuate.0f6fd271.svg";